// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3DbQD","obliqueLineWrap":"membershipbadge_obliqueLineWrap__33sxE","obliqueLine":"membershipbadge_obliqueLine__1lGDA"};